export const FEEDBACKS_ACTIONS = {
  SET_FEEDBACKS: 'SET_FEEDBACKS',
  SET_IS_LOADING: 'SET_IS_LOADING',
}
